import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveWorkPlace,
  createWorkPlace,
  deleteWorkPlace,
  getAllActiveWorkPlace,
  getAllWorkPlace,
  getWorkPlaceByID,
  WorkPlaceDetailsImageUpload,
  updateWorkPlace,
} from "./services/workPlace.services";
import { IWorkPlace, IWorkPlaces } from "./workPlaceModal";

const initialState: IWorkPlaces = {
  loading: false,
  formloading: false,
  error: "",
  WorkPlaceID: null,
  WorkPlaceList: [],
  WorkPlaceDetail: {
    ID: null,
    ServiceID: "",
    Title: "",
    Subtitle: "",
    Description: "",
    IsActive: 1,
  },
};

const workPlaceSlice = createSlice({
  name: "workplace",
  initialState,
  reducers: {
    clearWorkPlaceDetails: (state) => {
      state.WorkPlaceDetail = initialState.WorkPlaceDetail;
    },
    setWorkPlaceID: (state, action) => {
      state.WorkPlaceID = action.payload;
    },
    clearWorkPlaceID: (state) => {
      state.WorkPlaceID = initialState.WorkPlaceID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWorkPlace.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWorkPlace.fulfilled,
      (state, action: PayloadAction<IWorkPlace[]>) => {
        state.loading = false;
        state.WorkPlaceList = action.payload || [];
      }
    );
    builder.addCase(getAllWorkPlace.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WorkPlaceList = [];
    });
    builder.addCase(createWorkPlace.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createWorkPlace.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createWorkPlace.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWorkPlace.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWorkPlace.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWorkPlace.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWorkPlace.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWorkPlace.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWorkPlace.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWorkPlaceByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWorkPlaceByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.WorkPlaceDetail = action.payload;
    });
    builder.addCase(getWorkPlaceByID.rejected, (state, action) => {
      state.loading = false;
      state.WorkPlaceDetail = initialState.WorkPlaceDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveWorkPlace.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWorkPlace.fulfilled,
      (state, action: PayloadAction<IWorkPlace[]>) => {
        state.loading = false;
        state.WorkPlaceList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveWorkPlace.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WorkPlaceList = [];
    });
    builder.addCase(ActiveInactiveWorkPlace.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveWorkPlace.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveWorkPlace.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(WorkPlaceDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(WorkPlaceDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(WorkPlaceDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearWorkPlaceDetails, clearWorkPlaceID, setWorkPlaceID } =
  workPlaceSlice.actions;
export default workPlaceSlice.reducer;
